/**
 * @generated SignedSource<<12ceaa6b7724a82587a601a01903bd81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductExpireBatchesList_StoreProduct$data = {
  readonly activeExpireBatches: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProductExpireDateListItem_StoreProductExpireBatch">;
  }>;
  readonly id: string;
  readonly inActiveExpireBatches: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly expireAtDate: {
          readonly isoString: string;
        };
        readonly id: string;
      };
    }>;
  };
  readonly " $fragmentType": "ProductExpireBatchesList_StoreProduct";
};
export type ProductExpireBatchesList_StoreProduct$key = {
  readonly " $data"?: ProductExpireBatchesList_StoreProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchesList_StoreProduct">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "inActiveExpireBatches"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ProductExpireBatchesListRefetchableQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ProductExpireBatchesList_StoreProduct",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProductExpireBatch",
      "kind": "LinkedField",
      "name": "activeExpireBatches",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductExpireDateListItem_StoreProductExpireBatch"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "inActiveExpireBatches",
      "args": null,
      "concreteType": "StoreProductExpireBatchConnection",
      "kind": "LinkedField",
      "name": "__ProductExpireBatchesList_store_inActiveExpireBatches_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreProductExpireBatchEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StoreProductExpireBatch",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoreZonedDate",
                  "kind": "LinkedField",
                  "name": "expireAtDate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isoString",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "StoreProduct",
  "abstractKey": null
};
})();

(node as any).hash = "445e2a1b7a6d094c6b0082453bc29fa7";

export default node;
